import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class DocumentFieldValue extends AbstractModel {
  @autoserialize
  documentFieldId: number;

  @autoserialize
  documentId: number;

  @autoserialize
  value: string;
}
